import React from 'react';
import { MapPinIcon, PhoneIcon } from 'lucide-react';
import { company } from '../data/site';
import { Reveal } from './Reveal';
import { ButtonLink } from './ui/Button';
const communities = ['Orlando', 'Winter Park', 'Kissimmee', 'Altamonte Springs', 'Lake Mary', 'Sanford', 'Winter Garden', 'Central Florida'];
export function ServiceArea() {
  return <section id="service-area" aria-labelledby="service-area-heading" className="border-y border-charcoal-100 bg-charcoal-50 py-20 lg:py-28" data-id="element-217" data-mp="11z9jaq8lae0l">
      <div className="mx-auto grid max-w-container items-start gap-12 px-5 lg:grid-cols-[1fr_0.85fr] lg:gap-16 lg:px-8" data-id="element-218" data-mp="wzn8sok5bbvh">
        <Reveal data-id="element-219" data-mp="1axlivhrfom56">
          <p className="text-[13px] font-bold uppercase tracking-[0.16em] text-cobalt-700" data-id="element-220" data-mp="16ym3t4bzn900">
            Service Area
          </p>
          <h2 id="service-area-heading" className="mt-4 text-3xl font-extrabold leading-[1.12] tracking-tight text-charcoal-900 sm:text-[2.75rem]" data-id="element-221" data-mp="3csccwdd216qq">
            Serving Orlando &amp; Central Florida
          </h2>
          <p className="mt-6 max-w-xl text-lg leading-relaxed text-charcoal-600" data-id="element-222" data-mp="1a63zs7dy9nhv">
            CoPro Services proudly provides professional commercial and
            industrial services throughout Orlando and surrounding Central
            Florida communities.
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row" data-id="element-223" data-mp="1oy5vrgcwfwcm">
            <ButtonLink href="#contact" size="lg" data-id="element-224" data-mp="1twpi3hvena5i">
              Request a Free Quote
            </ButtonLink>
            <ButtonLink href={company.phoneHref} variant="outline" size="lg" data-id="element-225" data-mp="1xwhrtxwjbmcg">
              <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-226" data-mp="22w45u9k6t6mb" />
              Call {company.phoneDisplay}
            </ButtonLink>
          </div>
        </Reveal>

        <Reveal delay={0.08} className="rounded-lg border border-charcoal-200 bg-white p-7 sm:p-8" data-id="element-227" data-mp="27tcr4j0mtqrs">
          <p className="flex items-center gap-2 text-sm font-bold uppercase tracking-[0.14em] text-charcoal-500" data-id="element-228" data-mp="8kxw3tilislz">
            <MapPinIcon className="h-4 w-4 text-cobalt-700" aria-hidden="true" data-id="element-229" data-mp="5gqd69uefgxo" />
            {company.location}
          </p>
          <ul className="mt-6 flex flex-wrap gap-2" data-id="element-230" data-mp="1g6eh1u6g59f">
            {communities.map(place => <li key={place} className="rounded-md bg-charcoal-50 px-3 py-2 text-sm font-semibold text-charcoal-700" data-id="element-231" data-mp="fffvu4u4d5ez">
                {place}
              </li>)}
          </ul>
          <p className="mt-6 text-sm leading-relaxed text-charcoal-500" data-id="element-232" data-mp="oe1edzzlckfr">
            Serving commercial and industrial properties across the greater
            Orlando region. Contact us to confirm coverage for your location.
          </p>
        </Reveal>
      </div>
    </section>;
}